<template>
  <b-tabs content-class="">
    <b-tab
      v-for="(option, index) in storeItemsTabs"
      :key="index"
      @click="goTo(option.to)"
      :title-item-class="'custom-tab-outer-li'"
      :active="option.currentTab == $route.name ? true : false"
    >
      <template #title>
        <span v-b-popover.hover.bottomright="`${option.itemName}`">
          <img :src="`${option.itemImagePath}`" class="icon-tab" />
          <span>{{ option.itemName }}</span>
        </span>
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>
import { checkPrivilege } from "@/utils/functions";
import { hasProduct, hasCategory } from "@/utils/privilegeHelper";
import imgProducts from "@/assets/images/products.svg";
import imgCategories from "@/assets/images/categories.svg";

export default {
  name: "StoreItemsTabs",

  data() {
    return {};
  },
  methods: {
    checkPrivilege,
    hasProduct,
    hasCategory,
    goTo(path) {
      this.$router.push(path).catch(() => {});
    },
  },
  computed: {
    storeItemsTabs() {
      let tabs = [];
      if (checkPrivilege(hasProduct())) {
        tabs.push({
          to: {
            name: "Products",
          },
          itemName: this.$t("Products.modelName"),
          itemImagePath: imgProducts,
          currentTab: "Products",
        });
      }
      if (checkPrivilege(hasCategory())) {
        tabs.push({
          to: {
            name: "Categories",
          },
          itemName: this.$t("Categories.modelName"),
          itemImagePath: imgCategories,
          currentTab: "Categories",
        });
      }
      return tabs;
    },
  },
  watch: {},

  async created() {},
};
</script>
